import csFile from '../../helpers/floor-plan/translations/cs-CZ.json';
import enFile from '../../helpers/floor-plan/translations/en-XZ.json';
import esFile from '../../helpers/floor-plan/translations/es-ES.json';
import frFile from '../../helpers/floor-plan/translations/fr-FR.json';
import itFile from '../../helpers/floor-plan/translations/it-IT.json';
import plFile from '../../helpers/floor-plan/translations/pl-PL.json';
import ptFile from '../../helpers/floor-plan/translations/pt-PT.json';
import skFile from '../../helpers/floor-plan/translations/sk-SK.json';
import svFile from '../../helpers/floor-plan/translations/sv-SE.json';
import zhFile from '../../helpers/floor-plan/translations/zh-CN.json';
import { replaceNullWithQuotesJson } from '../../helpers/utils';

export const navigationTranslator = (locale: string) => {
  let translation = {};
  switch (locale) {
    case 'sv':
      translation = {
        maneuvers: replaceNullWithQuotesJson(svFile.maneuvers),
        nextManeuvers: replaceNullWithQuotesJson(svFile.nextManeuvers),
        keywords: replaceNullWithQuotesJson(svFile.keywords),
        durations: replaceNullWithQuotesJson(svFile.durations),
        internal: replaceNullWithQuotesJson(svFile.internal),
      };
      break;
    case 'en':
      translation = {
        maneuvers: replaceNullWithQuotesJson(enFile.maneuvers),
        nextManeuvers: replaceNullWithQuotesJson(enFile.nextManeuvers),
        keywords: replaceNullWithQuotesJson(enFile.keywords),
        durations: replaceNullWithQuotesJson(enFile.durations),
        internal: replaceNullWithQuotesJson(enFile.internal),
      };
      break;
    case 'pt':
      translation = {
        maneuvers: replaceNullWithQuotesJson(ptFile.maneuvers),
        nextManeuvers: replaceNullWithQuotesJson(ptFile.nextManeuvers),
        keywords: replaceNullWithQuotesJson(ptFile.keywords),
        durations: replaceNullWithQuotesJson(ptFile.durations),
        internal: replaceNullWithQuotesJson(ptFile.internal),
      };
      break;
    case 'zh-CN':
      translation = {
        maneuvers: replaceNullWithQuotesJson(zhFile.maneuvers),
        nextManeuvers: replaceNullWithQuotesJson(zhFile.nextManeuvers),
        keywords: replaceNullWithQuotesJson(zhFile.keywords),
        durations: replaceNullWithQuotesJson(zhFile.durations),
        internal: replaceNullWithQuotesJson(zhFile.internal),
      };
      break;
    case 'pl':
      translation = {
        maneuvers: replaceNullWithQuotesJson(plFile.maneuvers),
        nextManeuvers: replaceNullWithQuotesJson(plFile.nextManeuvers),
        keywords: replaceNullWithQuotesJson(plFile.keywords),
        durations: replaceNullWithQuotesJson(plFile.durations),
        internal: replaceNullWithQuotesJson(plFile.internal),
      };
      break;
    case 'fr':
      translation = {
        maneuvers: replaceNullWithQuotesJson(frFile.maneuvers),
        nextManeuvers: replaceNullWithQuotesJson(frFile.nextManeuvers),
        keywords: replaceNullWithQuotesJson(frFile.keywords),
        durations: replaceNullWithQuotesJson(frFile.durations),
        internal: replaceNullWithQuotesJson(frFile.internal),
      };
      break;
    case 'es':
      translation = {
        maneuvers: replaceNullWithQuotesJson(esFile.maneuvers),
        nextManeuvers: replaceNullWithQuotesJson(esFile.nextManeuvers),
        keywords: replaceNullWithQuotesJson(esFile.keywords),
        durations: replaceNullWithQuotesJson(esFile.durations),
        internal: replaceNullWithQuotesJson(esFile.internal),
      };
      break;
    case 'it':
      translation = {
        maneuvers: replaceNullWithQuotesJson(itFile.maneuvers),
        nextManeuvers: replaceNullWithQuotesJson(itFile.nextManeuvers),
        keywords: replaceNullWithQuotesJson(itFile.keywords),
        durations: replaceNullWithQuotesJson(itFile.durations),
        internal: replaceNullWithQuotesJson(itFile.internal),
      };
      break;
    case 'cs':
      translation = {
        maneuvers: replaceNullWithQuotesJson(csFile.maneuvers),
        nextManeuvers: replaceNullWithQuotesJson(csFile.nextManeuvers),
        keywords: replaceNullWithQuotesJson(csFile.keywords),
        durations: replaceNullWithQuotesJson(csFile.durations),
        internal: replaceNullWithQuotesJson(csFile.internal),
      };
      break;
    case 'sk':
      translation = {
        maneuvers: replaceNullWithQuotesJson(skFile.maneuvers),
        nextManeuvers: replaceNullWithQuotesJson(skFile.nextManeuvers),
        keywords: replaceNullWithQuotesJson(skFile.keywords),
        durations: replaceNullWithQuotesJson(skFile.durations),
        internal: replaceNullWithQuotesJson(skFile.internal),
      };
      break;
    default:
      break;
  }
  return translation;
};
